// ============================================================
// เอกสาร ใบเสร็จรับเงิน (รายรับอื่นๆ)  (/doc/receipt-other)
// ------------------------------------------------------------
// หน้านี้เปิดในแท็บใหม่จากหน้าจออื่น ๆ ผ่าน openDocument()
// ข้อมูลที่จะพิมพ์ถูกส่งมาทาง localStorage คีย์ "DATA_"
// รูปแบบเอกสาร (เปิด/ปิดแต่ละส่วน ข้อความหัว-ท้าย) มาจากหน้าตั้งค่าเอกสาร
// ============================================================

import React, { Component } from "react";
// เพิ่ม loading ใน import
import { readStorageJSON, tokens, GET, getStorage, toFixed, replaceTextHTML, loading } from "../../shared/index.js";
import LOGO from "../../assets/images/logo.png";
import THBText from "thai-baht-text";
import "../../assets/css/bootstrap.css";
import "../../assets/css/index.css";

const size = {
  A4: { width: 1116, height: 1578 },
  A5: { width: 1116, height: 1578, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 1371, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 1371, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 806, zoom: 0.77 },
};

export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      setting: {
        size: "A4", paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0,
        header_1: { status: true, title: "-รูปภาพ" },
        header_2: { status: true, title: "" },
        header_3: { status: true, title: "" },
        header_4: { status: true, title: "-ใบเสร็จรับเงิน" },
        header_5: { status: true, title: "-เลขที่" },
        header_6: { status: true, title: "-วันที่" },
        header_7: { status: true, title: "-ได้รับเงินจาก" },
        header_8: { status: true, title: "-ที่อยู่" },
        header_9: { status: true, title: "-ชำระโดย" },
        header_10: { status: true, title: "-วันที่" },
        th_1: { status: true, title: "-ลำดับ" },
        th_2: { status: true, title: "-รายการ" },
        th_3: { status: true, title: "-รวมเป็นเงิน" },
        tr_4: { status: true, title: "-รวมเป็นเงิน" },
        tr_5: { status: true, title: "-ปรับปรุงยอดเงิน" },
        tr_6: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },
        footer_1: { status: true, title: "-จำนวนเงิน (ตัวอักษร)" },
        footer_2: { status: true, title: "" },
        footer_3: { status: true, title: "-ลงชื่อ" },
        footer_4: { status: true, title: "" },
        footer_5: { status: true, title: "" },
      },
    };
  }

  async componentDidMount() {
    loading(false); // เรียกใช้งานทันทีตั้งแต่เข้ามาหน้าแรก
    await this.Get();
    
    const localData = readStorageJSON("DATA_");
    if (localData) this.setState({ data: localData });

    await replaceTextHTML();
    setTimeout(() => window.print(), 1000);
  }

  Get = async () => {
    loading(true);
    let result = await GET(tokens, `v1/TH/document-manage/detail/custom-document/${getStorage("project_id")}`);
    if (result?.status && result.data?.data?.receipt_other) {
      this.setState({ setting: result.data.data.receipt_other });
    }
    loading(false);
  };

  render() {
    const { setting: s, data: d } = this.state;

    // Helper สำหรับซ่อน Element ถ้าระบุว่า false
    const chk = (key) => (!s[key]?.status ? "d-none" : "");
    const hideHeaderTop = (!s.header_1?.status && !s.header_2?.status && !s.header_3?.status && !s.header_4?.status && !s.header_5?.status && !s.header_6?.status) ? "d-none" : "";
    const hideHeader7to10 = (!s.header_7?.status && !s.header_8?.status && !s.header_9?.status && !s.header_10?.status) ? "d-none" : "";

    // คำนวณยอดรวมเพื่อใช้งานในตาราง
    const totalVal = Number(d?.total || 0);
    const satangVal = Number(d?.change_satang || 0);
    const grandTotal = totalVal + satangVal;

    return (
      <div className="w-100">
        <div 
          className={`mx-auto bg-white ${s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf"}`} 
          style={{
            ...size[s.size || "A4"],
            paddingLeft: Number(s.paddingLeft),
            paddingRight: Number(s.paddingRight),
            paddingTop: Number(s.paddingTop),
            paddingBottom: Number(s.paddingBottom),
          }}>
          <table className="table table-bordered mb-0 header">
            <tbody>
              <tr className={hideHeaderTop}>
                <td rowSpan={2} className="border-bottom-0">
                  <div className="d-flex align-items-center">
                    <img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain ${chk("header_1")}`} />
                    <div>
                      <h2 className={`fw-bold px-2 mb-0 ${chk("header_2")}`}>{s.header_2?.title || ""}</h2>
                      <div className={`px-2 ${chk("header_3")}`}>
                        {s.header_3?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>)}
                      </div>
                    </div>
                  </div>
                </td>
                <td className={`wpx-250 text-center border-bottom-0 ${chk("header_4")}`}>
                  <h2 className="fw-bold mb-0">ใบเสร็จรับเงิน</h2>
                </td>
              </tr>
              <tr className={hideHeaderTop}>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_5")}>เลขที่ : {d?.number}</div>
                  <div className={chk("header_6")}>วันที่ : {d?.date}</div>
                </td>
              </tr>
              <tr className={hideHeader7to10}>
                <td className="border-bottom-0">
                  <div className={chk("header_7")}>ได้รับเงินจาก : {d?.cutomer_name}</div>
                  <div className={chk("header_8")}>ที่อยู่ : {d?.cutomer_address}</div>
                </td>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_9")}>ชำระโดย : {d?.payment}</div>
                  <div className={chk("header_10")}>วันที่ : {d?.payment_date}</div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <table className="table table-bordered mb-0">
            <tbody>
              <tr>
                <td className={`py-1 text-center wpx-50 ${chk("th_1")}`}>ลำดับ</td>
                <td className={`py-1 border-right-0 w-100 ${chk("th_2")}`}>รายการ</td>
                <td className={`py-1 border-left-0 wpx-130 ${chk("th_2")}`}></td>
                <td className={`py-1 text-center wpx-120 ${chk("th_3")}`}>รวมเป็นเงิน</td>
              </tr>
              <tr>
                <td className={`pt-1 text-center py-1 ${chk("th_1")}`}>1</td>
                <td className={`pt-1 border-right-0 ${chk("th_2")}`}>
                  {d?.title} {d?.description ? `(${d.description})` : ""}
                </td>
                <td className={`border-left-0 ${chk("th_2")}`}></td>
                <td className={`text-right ${chk("th_3")}`}>{toFixed(d?.cost)}</td>
              </tr>
              <tr>
                <td className={`text-center ${chk("th_1")}`} colSpan={4} style={{ height: 250 }}></td>
              </tr>
              <tr>
                <td colSpan={(s.th_1.status ? 1 : 0) + (s.th_2.status ? 1 : 0)} rowSpan={3} className="border-0">
                  <div className="d-flex">
                    <div className="w-100">
                      <div className={`w-100 d-flex position-relative mt-3 mb-2 text-nowrap ${chk("footer_1")}`}>
                        จำนวนเงิน (ตัวอักษร)
                        <div className="w-100 pl-1 position-relative">
                          ....................................................................................
                          <span className="position-absolute" style={{ left: 6, bottom: 4 }}>
                            {THBText(grandTotal)}
                          </span>
                        </div>
                      </div>
                      <br />
                      <div className={chk("footer_2")}>
                        {s.footer_2?.title?.split("\n").map((e, i) => <div key={i} className="mb-1">{e}</div>)}
                      </div>
                    </div>
                    <div className="text-center">
                      <br /><br /><br />
                      <div className={`text-nowrap ${chk("footer_3")}`}>ลงชื่อ...............................................ผู้รับเงิน</div>
                      <div className={chk("footer_4")}>({s.footer_4?.title || ""})</div>
                      <div className={chk("footer_5")}>{s.footer_5?.title || ""}</div>
                    </div>
                  </div>
                </td>
                <td className={`text-right pr-1 border-0 ${chk("tr_4")}`}>รวมเป็นเงิน</td>
                <td className={`text-right ${chk("tr_4")}`}>{toFixed(totalVal)}</td>
              </tr>
              <tr className={chk("tr_5")}>
                <td className="text-right pr-1 border-0">ปรับปรุงยอดเงิน</td>
                <td className="text-right">{toFixed(satangVal)}</td>
              </tr>
              <tr className={chk("tr_6")}>
                <td className="text-right pr-1 border-0">รวมเป็นเงินทั้งสิ้น</td>
                <td className="text-right">{toFixed(grandTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}